/**
 * modules
 */

import preloader from '../../../templates/_atoms/preloader/_script';
import codeSnippet from '../../../templates/_atoms/codeSnippet/_script';
import pageTitle from '../../../templates/_molecules/pageTitle/_script';
import imageSlider from '../../../templates/_organisms/imageSlider/_script';
import imageGallery from '../../../templates/_organisms/imageGallery/_script';
import objectSlider from '../../../templates/_organisms/objectSlider/_script';
import appHeader from '../../../templates/_organisms/appHeader/_script';
import cards from '../../../templates/_organisms/cards/_script';
import newsCards from '../../../templates/_organisms/newsCards/_script';
// import accordion    from '../../../templates/_templates/accordion/_main'
// import cookiebar    from '../../../templates/_modules/cookiebar/_main'
// import imageSlider  from '../../../templates/_modules/imageSlider/_main'
// import imageGallery from '../../../templates/_modules/imageGallery/_main'
// import navCategories from '../../../templates/_modules/navCategories/_main'

// Modules Array
const modulesArray = [
    preloader,
    codeSnippet,
    imageSlider,
    imageGallery,
    objectSlider,
    appHeader,
    cards,
    newsCards,
    pageTitle,
    // accordion,
    // cookiebar,
    // imageGallery,
    // navCategories
];

const modules = {
    // Modules
    Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach((module) => {
                module.init();
            });
        }
    },

    init() {
        this.Modules();
    }
};

export default modules;



// WEBPACK FOOTER //
// ./___src/assets/js/partials/modules.js